import { useUserContextHook } from "../../hooks/useUserContextHook";
import { UserEnum } from "../../utils/app-common";
import NoAccessComponent from "../CommonComponent/NoAccessComponent";

type Props = { children: JSX.Element, access: number[], isRoute?: boolean, isEmployee?: boolean, isAccess?: boolean }
const AccessControlComponent = ({ children, access, isRoute = false, isEmployee = false, isAccess = false }:
    Props) => {

    const { employeeDetail } = useUserContextHook()
    const { positionId, employeeId } = employeeDetail ?? {};
    const isAllowed = access?.some(role => (isEmployee ? employeeId : positionId === role));

    if (positionId === UserEnum.ADMIN) {
        return <>{children}</>
    }

    if ((!isAllowed && !isAccess) && isRoute) {
        return (<NoAccessComponent />)
    }

    return (
        <>
            {(isAllowed || isAccess) ? children : null}
        </>
    )
}

export default AccessControlComponent